import { BaseService, BaseServiceOptions } from '../../api/services/base-service';
import { PagedResponse } from '../../common';
import { Type } from '../interfaces';
import { ListTypesRequest, SearchTypesRequest } from './types.service.interfaces';

export class TypesService extends BaseService {
  typesApiUrl: string;

  constructor(opts: BaseServiceOptions) {
    super(opts);
    this.typesApiUrl = `${this.apiUrl}/marketplace/v1/types`;
  }

  list(req: ListTypesRequest = {}) {
    return this.get<Type[], ListTypesRequest>(`${this.typesApiUrl}/list`, req);
  }

  search(req: SearchTypesRequest = {}) {
    return this.get<PagedResponse<Type>, SearchTypesRequest>(this.typesApiUrl, req);
  }

  getById(id: string) {
    return this.get<Type>(`${this.typesApiUrl}/${id}`);
  }

  listFromAssets() {
    return this.post<Type[], object>(`${this.typesApiUrl}/load`, {});
  }
}
